module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAXCAYAAAAC9s/ZAAABBUlEQVQ4je3SL0tDYRTH8Y/ezYnFPxhNayKIWZNgEUGTUdbEYNMX4CvwDdhsWsQiyh2IiF0wyJJREMEgTJxsWp7LLkPnvTcZPPDAww++33MOnIE4jk+xhBH56gP1ElZDcBbCSgb4HWtYLoXgAis4xhQmfgA/cY9dPGIrEbxgHuu4Qx1RD9xBGTU00IZEEKWAKxxh8JvulSCIMJQWDOMp/LfD61cNzKQF0yGcRBXjfeA2bnCSFjxjNHTex+svE0iaJHs+YA572MkAQystKOMt/JsZBeiuUMUtNnFeRDAWRjrIA9NdoZUX7BUUrn/BXxIUuYMm3UucxWFOwWIiuMQCNnIKOrj+AmhjMJZqEkybAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/51.png
// module id = azVe
// module chunks = 0